import React, { useState } from "react";

const OfferModal = ({ isOpen, onClose, promotion }) => {
  // Call useState unconditionally at the top
  const [showAll, setShowAll] = useState(false);

  // Early return if modal is not open
  if (!isOpen) return null;

  // Limit to the first 6 offers
  const displayedDiscounts = showAll
    ? promotion.discounts
    : promotion.discounts.slice(0, 6);

  return (
    <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded-lg shadow-xl border-2 border-red-600 w-full max-w-md relative">
        {/* Close X button */}
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 text-2xl"
        >
          ✕
        </button>

        <h2 className="text-xl font-semibold text-red-600 mb-4">
          🎄 Special Offers! 🎄
        </h2>
        {/* Display the promotion title */}
        <p className="mb-4">{promotion.name}</p>

        {/* Iterate over the discounts and display details */}
        <div className="mb-4">
          {displayedDiscounts.map((discount) => (
            <div key={discount._id} className="mb-2">
              <p>
                <strong>🎁 Buy {discount.buyX} item(s)</strong> and get{" "}
                <strong>{discount.discountOnNext}% off</strong> on your next
                {discount.maxApplications} item.
                <br />
              </p>
            </div>
          ))}
        </div>

        {/* Show "See More" if there are more than 6 offers */}
        {promotion.discounts.length > 6 && !showAll && (
          <div className="mt-2">And More &hellip;</div>
        )}

        {showAll && promotion.discounts.length > 6 && (
          <button
            onClick={() => setShowAll(false)}
            className="text-blue-500 hover:text-blue-700 mt-2"
          >
            Show Less
          </button>
        )}
      </div>
    </div>
  );
};

export default OfferModal;
